var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefaultPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.625 135.625a33.909 33.909 0 00-26.25-24.063C87.5 107.406 85.312 100.625 85.312 96.25v-7c7.876-7.219 15.313-19.031 15.313-32.375v-21c0-22.75-16.188-31.5-30.625-31.5-14.438 0-30.625 8.75-30.625 31.5v21c0 13.563 7.438 25.156 15.313 32.375v7c0 4.375-4.376 11.375-26.25 15.312a29.317 29.317 0 00-24.063 24.063",
    stroke: "#000064",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconDefaultPerson;